import React, { useEffect, useState } from "react";

import moment from "moment";

import { useUser, usePopup, useData } from "../zustand/store.js";

import { LangText } from "../zustand/dict.js";
// import { lang } from '../utils/utils';

export default function Term() {

    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    
   
    return (
        <>
            <div className="content">
                <p>약관</p>
            </div>
        </>
    );
}
